import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_BASE_URL } from '@/config/env';
import i18n from '@/i18n';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Request interceptor - authentication is handled via httpOnly cookies
apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.headers.set('Accept-Language', i18n.language === 'ar' ? 'ar' : 'en');
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Cookie will be cleared by backend. Avoid reloading /login on its own
      // auth bootstrap 401, which creates a redirect loop on mobile browsers.
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
